import { promise } from '../../../helpers';
import { setMenuSession } from './index';

const setActiveMenuSession = menuIndex => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        const { auth } = getState();
        const { menu } = auth;

        dispatch(
            setMenuSession(
                menu.map((v, loopIndex) => ({
                    ...v,
                    isActive: menuIndex === loopIndex,
                })),
            ),
        );

        return promise();
    };
};

export default setActiveMenuSession;
